import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { NzInputModule } from 'ng-zorro-antd/input';
import { CustomizeTextareaComponent } from './customize-textarea.component';

@NgModule({
    declarations: [CustomizeTextareaComponent],
    imports: [
        CommonModule,
        FormsModule,
        NzInputModule,
    ],
    exports: [CustomizeTextareaComponent],
})
export class CustomizeTextareaModule {}
